import Button from "components/common/Button";
import Typography from "components/common/Typography";
import { getUserName } from "utils/CommonFunctions";

interface Props {
  setCurrentPage?: any;
}

function WelcomeWizard(props: Props) {
  return (
    <>
      <Typography variant={"h4"}>Welcome, {getUserName()}</Typography>
      <Typography>
        Welcome to Hilton BOOST! Set preferences that fit you and match your goals to tailor your experience.
      </Typography>
      <Button variant="primary" label="Let's Start" width="150px" onClick={() => props.setCurrentPage(2)} />
    </>
  );
}

export default WelcomeWizard;
